module.exports = "/img/google_plus.png?1fb1624629372cfa3d782fee697dcd1b";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/google_plus.png
// module id = wCsn
// module chunks = 75